import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BackToTop from '../../components/BackToTop/BackToTop';
import './About.css';

const About = () => {
  const [counters, setCounters] = useState({
    years: 0,
    subsidiaries: 0,
    divisions: 0
  });

  useEffect(() => {
    const animateCounters = () => {
      const duration = 2000;
      const steps = 60;
      const stepDuration = duration / steps;

      const targets = {
        years: 48,
        subsidiaries: 11,
        divisions: 3
      };

      let currentStep = 0;

      const counterInterval = setInterval(() => {
        currentStep++;
        const progress = currentStep / steps;

        setCounters({
          years: Math.floor(progress * targets.years),
          subsidiaries: Math.floor(progress * targets.subsidiaries),
          divisions: Math.floor(progress * targets.divisions)
        });

        if (currentStep >= steps) {
          clearInterval(counterInterval);
          setCounters(targets);
        }
      }, stepDuration);

      return () => clearInterval(counterInterval);
    };

    // Start counter animation when component mounts
    animateCounters();
  }, []);

  const directors = {
    trimlineGroup: [
      {
        name: "Sohaib Saleem",
        role: "CEO Trimline Group",
        image: "/directors/Sohaib saleem.png",
        linkedin: "https://www.linkedin.com/in/msohaibsaleem/",
        bio: "Specializes in technology integration and trade business across multiple countries."
      },
      {
        name: "Usman Saleem",
        role: "CEO Khazanay",
        image: "/directors/Usman saleem.png",
        linkedin: "https://www.linkedin.com/in/mhdusmansaleem/",
        bio: "Experienced in E-Commerce Business and Footware brands across Pakistan."
      }
    ],
    trimlinePolymers: [
      {
        name: "Ahmed Jamal",
        role: "CEO Trimline Polymers",
        image: "/directors/Ahmed jamal.jpg",
        linkedin: "https://www.linkedin.com/in/ahmad-jamal-2121201b/",
        bio: "Business Leader & Turnaround Specialist with 30+ years of B2B & B2C business management experience in Pakistan, and across the globe"
      },
      {
        name: "Ahsum Haleem",
        role: "Director",
        image: "/directors/Ahsum Haleem.jpg",
        linkedin: "https://www.linkedin.com/in/ahsum-haleem-233a8517/",
        bio: "Polymer Business & B2B sales expert across the globe"
      },
      {
        name: "Mustafa Shakeel",
        role: "COO Trimline Group",
        image: "/directors/Mustafa shakeel.png",
        linkedin: "https://www.linkedin.com/in/ghulam-muhammad-mustafa-shakeel-8aa393147/",
        bio: "Strategic leader with expertise in global supply chain management and business development."
      }
    ]
  };

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-background">
          <video className="hero-video" autoPlay muted loop playsInline>
            <source src="/video/video1.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">About Trimline Group</h1>
            <p className="hero-subtitle">Nearly five decades of excellence in global supply chain solutions and diversified business operations</p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">{counters.years}</span>
                <span className="stat-label">Years of Excellence</span>
              </div>
              <div className="stat">
                <span className="stat-number">{counters.subsidiaries}</span>
                <span className="stat-label">Subsidiaries</span>
              </div>
              <div className="stat">
                <span className="stat-number">{counters.divisions}</span>
                <span className="stat-label">Divisions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Page Content */}
      <section className="page-content">
        <div className="container">
          {/* Directors Section */}
          <div className="directors-section">
            <h2 className="section-title">Our Leadership</h2>
            <br /><br />
            <p className="section-subtitle">
              Meet the visionaries steering <strong>Trimline Group</strong> towards global excellence
            </p>

            <br /><br />
            {/* Trimline Group */}
            <h3 className="director-category">Trimline Group</h3>
            <div className="directors-container">
              {directors.trimlineGroup.map((director, index) => (
                <div className="director-card" key={index}>
                  <div className="director-image">
                    <img src={director.image} alt={director.name} />
                    <div className="director-overlay">
                      <div className="social-links">
                        <a href={director.linkedin} target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-linkedin"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="director-info">
                    <h3>{director.name}</h3>
                    <p className="role">{director.role}</p>
                    <div className="director-bio">
                      <p>{director.bio}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Trimline Polymers */}
            <h3 className="director-category">Trimline Polymers</h3>
            <div className="directors-container">
              {directors.trimlinePolymers.map((director, index) => (
                <div className="director-card" key={index}>
                  <div className="director-image">
                    <img src={director.image} alt={director.name} />
                    <div className="director-overlay">
                      <div className="social-links">
                        <a href={director.linkedin} target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-linkedin"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="director-info">
                    <h3>{director.name}</h3>
                    <p className="role">{director.role}</p>
                    <div className="director-bio">
                      <p>{director.bio}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Company Overview */}
          <div className="content-section">
            <div className="content-with-visual">
              <div className="content-text">
                <h2>Our Story</h2>
                <p>Trimline Group, established in 1977, is a pioneer in global supply chain solutions and diversified business operations. With nearly five decades of excellence behind it, the Group has grown into a diversified business powerhouse with a growing focus on e-commerce and digital consumer brands.</p>
                <p>Our international trade business unit is divided into various companies including <strong>Polymers, Chemicals Jade chemi and AgriCommodities.</strong></p>
              </div>
              <div className="content-visual">
                <div className="timeline-visual">
                  <div className="timeline-milestone">
                    <div className="milestone-year">1977</div>
                    <div className="milestone-dot"></div>
                    <div className="milestone-text">Founded</div>
                  </div>
                  <div className="timeline-milestone">
                    <div className="milestone-year">1990s</div>
                    <div className="milestone-dot"></div>
                    <div className="milestone-text">Global Expansion</div>
                  </div>
                  <div className="timeline-milestone">
                    <div className="milestone-year">2000s</div>
                    <div className="milestone-dot"></div>
                    <div className="milestone-text">Diversification</div>
                  </div>
                  <div className="timeline-milestone">
                    <div className="milestone-year">Today</div>
                    <div className="milestone-dot"></div>
                    <div className="milestone-text">Innovation Leader</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Business Divisions */}
          <div className="divisions-section">
            <h2 className="section-title">Our Business Divisions</h2>
            <p className="section-subtitle">Diversified portfolio driving global growth and innovation</p>
            
            <div className="divisions-grid">
              <div className="division-card">
                <div className="division-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <h3>International Trade</h3>
                <p>Global supply chain solutions across polymers, chemicals, and commodities</p>
                <Link to="/trade" className="btn">Explore <i className="fas fa-arrow-right"></i></Link>
              </div>
              
              <div className="division-card">
                <div className="division-icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
                <h3>E-Commerce & Brands</h3>
                <p>Leading Pakistan's digital footware retail with Khazanay, Fadano, and Birdsoles and FMCG brands</p>
                <Link to="/brands" className="btn">Explore <i className="fas fa-arrow-right"></i></Link>
              </div>
              
              <div className="division-card">
                <div className="division-icon">
                  <i className="fas fa-microchip"></i>
                </div>
                <h3>Technology</h3>
                <p>Innovative AI powered solutions with Powerpresent.ai, Yaara.ai and Sawda.ai</p>
                <Link to="/tech" className="btn">Explore <i className="fas fa-arrow-right"></i></Link>
              </div>
            </div>
          </div>

          {/* Mission & Values */}
          <div className="values-section">
            <div className="values-content">
              <div className="mission-card">
                <h2>Our Mission</h2>
                <p>To provide the most competitive price to our valued clientele while maintaining the highest standards of quality and service in international trade and supply chain management.</p>
              </div>
              
              <div className="values-card">
                <h2>Our Values</h2>
                <ul>
                  <li><i className="fas fa-check-circle"></i> Integrity and transparency in all business operations</li>
                  <li><i className="fas fa-check-circle"></i> Commitment to quality and customer satisfaction</li>
                  <li><i className="fas fa-check-circle"></i> Innovation in supply chain solutions</li>
                  <li><i className="fas fa-check-circle"></i> Building long-term partnerships with clients and suppliers</li>
                  <li><i className="fas fa-check-circle"></i> Global perspective with local expertise</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BackToTop />
    </div>
  );
};

export default About;